import React, {Dispatch, memo, SetStateAction, useMemo} from 'react';
import argos from '../../assets/argos.svg';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark, faArrowCircleLeft} from '@fortawesome/free-solid-svg-icons'
import {useMoralis} from "react-moralis";
import {IUser} from "../../types/type";


interface IHeader {
    setUser : Dispatch<SetStateAction<IUser>>
    logo : string
}

const Header: React.FC<IHeader> = ({setUser , logo}) => {

    const {logout : moralisLogOut , isAuthenticated} = useMoralis()

    const logout = async () => {
        await moralisLogOut().then(() => {
            setUser({
                objectId : "",
                id : "",
                className : ""
            })
        })
    }

    const headerImg : string = useMemo(() => {
        return logo ? logo : argos
    },[logo])


    return (
        <section className={'flex flex-row-reverse justify-between px-3 bg-blue-500 py-4 w-full relative'}>
            <div className={'p-4 border-white border-4 shadow-sm bg-white w-16 h-16 rounded-full absolute left-1/2 top-4/10'} style={{transform: 'translate3D(-50%,0,0)', zIndex : 3}}>
                <img src={headerImg} alt={'argos-id'} className={'w-full h-auto'}/>
            </div>
            <FontAwesomeIcon onClick={logout} icon={faCircleXmark} className={'ml-1.5 text-white cursor-pointer'}/>
        </section>
    )
}

export default memo(Header)